var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconnext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.31274 16.2652C6.08773 16.4764 5.73522 16.4688 5.51942 16.2483C5.29706 16.0211 5.30487 15.6556 5.53674 15.4381L11.5789 9.77042C12.4212 8.98034 12.4212 7.64311 11.5789 6.85302L5.53674 1.18539C5.30487 0.967892 5.29706 0.602314 5.51942 0.375111C5.73522 0.154601 6.08773 0.147085 6.31274 0.358194L13.2354 6.85317C14.0775 7.64322 14.0775 8.98022 13.2354 9.77028L6.31274 16.2652ZM8.30554 9.77028C9.14762 8.98022 9.14762 7.64322 8.30554 6.85317L1.38284 0.358195C1.15783 0.147085 0.805329 0.154601 0.589521 0.37511C0.367162 0.602314 0.374976 0.967892 0.606841 1.18539L6.64898 6.85302C7.49127 7.6431 7.49127 8.98034 6.64898 9.77042L0.606842 15.4381C0.374976 15.6556 0.367162 16.0211 0.589521 16.2483C0.80533 16.4688 1.15783 16.4764 1.38284 16.2652L8.30554 9.77028Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconnext);
export default __webpack_public_path__ + "static/media/iconnext.3084a14609b5f9cbeeffb9ce3caeaada.svg";
export { ForwardRef as ReactComponent };